import { UserType } from '../../core/users/users.types';

export function ensureName(profile: UserType | undefined): UserType {
  return {
    ...profile,
    name: `${profile?.firstName || ''} ${profile?.lastName || ''}`,
  } as UserType;
}
